import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import { ExcelServicesService } from "../../../services/excel.service";
import { StorageService } from "../../../services/storage.service";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-detailed-staff-usage-report",
  templateUrl: "./detailed-staff-usage-report.component.html",
  styleUrls: ["./detailed-staff-usage-report.component.css"],
})
export class DetailedStaffUsageReportComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });

  total_count = 0;
  video: any;
  vid: any;
  maxDate = new Date();
  is_active: any;
  getVideo: any;
  videoList: any[] = [];
  searchForm: FormGroup;
  uivideoList: any;
  excelVideoList: any[];
  classroom_id: any;
  subject_id: any;
  filter_from: any;
  filter_end: any;
  prolength: number = 0;
  department_id: string;
  form: FormGroup;
  batch_id: string;
  filter: any;
  classroom: any;
  class: any;
  batch: any;
  total: number;
  batchData1: any;
  videoList1: any;
  prolength1: number;
  pageno: any;
  recrange: any;
  limit: number = 10;
  dropbox: Array<Object> = [];
  allVideoDetails: any[] = [];
  getAllVideoDetails: any;
  allVideoDetailsCountvalue: number = 0;
  check: number;
  offset = 1;
  filtervalues: boolean;
  chiparray = [];
  p: number;
  page: number = 1;
  page_size: number = 10;
  pagedItems: any[];
  pageshow: boolean = true;
  htmlpageshow: boolean;
  showLoadMore: boolean;
  page_count: any[];
  countvalue: number = 0;
  department: any;
  departmentData: any;
  selectedList: any;
  hod: any;
  sessionData: any;
  minDate: Date;
  findedVal: any;
  professorname: Object;
  professorData: any;
  professor_id: any;
  role: number;
  constructor(
    private storageService: StorageService,
    private datepipe: DatePipe,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private ExcelServicesService: ExcelServicesService,
    public commonService: CommonService
  ) {
    this.role = this.storageService.getRole();
    this.hod = this.storageService.getHod();
  }
  async ngOnInit() {
    this.maxDate = new Date();
    this.minDate = new Date();
    this.searchForm = this.fb.group({
      id: [""],
      date: ["", [Validators.required]],
      depname: [null],
      class_room_no: [null],
      proname: [""],
      session: [null],
    });
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    
    if (this.storageService.getRole() == 4 && this.hod !== 1 ) {
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].setValue(this.professor_id);
      this.searchForm.controls["proname"].disable();
    }
    await this.getDepartmentAndClassroom();
    await this.getProfessor();
    await this.getSession();
    //this.getDetailedStaffUsageReport();
  }

  async getDepartmentAndClassroom() {
    this.spinner.show();
    let requestPayload = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      department_id: this.department_id,
      classroom_id: this.classroom_id,
      subject_id: this.subject_id,
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      requestPayload
    );
    this.departmentData = this.department["content"];
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      requestPayload
    );
    this.class = this.classroom["content"];
    this.spinner.hide();
  }

  async getPage(page: number) {
    this.offset = page;
    await this.getDetailedStaffUsageReport();
    const res = await this.serverCall(this.videoList, page);
    this.total = this.countvalue;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.limit;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  get forms() {
    return this.searchForm.controls;
  }

  async getSession() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );

    this.sessionData = session["content"];
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchForm.controls['session']?.value
    );
    this.onSessionChangeEvent(true);
    this.doFilter();
    this.spinner.hide();
  }

  onSessionChangeEvent(isInitLoad?) {
    this.forms["date"].setValue(null);
    this.getFilterDate(null);
    let sessionVal = this.forms["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        let splitedChipArray = null;
        if(this.chiparray.length){
          this.chiparray.forEach((elem)=>{
            if(elem.split(" : ")[0] === "Date" ){
              splitedChipArray =  elem.split(" : ")[1].split(" - ");
            }
          })
        }
        if(splitedChipArray?.length){
          const convertedDates = splitedChipArray.map(dateStr => new Date(dateStr));
          this.forms["date"].setValue(convertedDates);
          this.getFilterDate(convertedDates);
        }else{
        this.forms["date"].setValue([new Date(), new Date()]);
        this.getFilterDate([new Date(), new Date()]);
      }
    }
    } else {
      this.forms["date"].setValue(null);
      this.getFilterDate(null);
    }
  }

  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;

      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
            new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 180) {
        Swal.fire({
          text: "Please select dates within 180 days",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
      }
    //  this.searchForm.controls["date"].setValue(""); 
    }
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(dateValue, timeValue, isDateRequested);
  }

  getvalue(event: any, rec: any, offset: number) {
    this.recrange = rec;
    this.pageno = event;
    this.offset = offset;
    this.exportAsXLSX();
  }

  async dropboxdown() {
    this.dropbox = [];
    var count = 1000,
      tempcount = 1000,
      c1,
      c2;
    var offset = 0;
    this.check = Math.ceil(this.countvalue / count);
    var cvar = 1;
    for (let i = 1; i <= this.check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2, offset: offset });
      offset += 1000;
    }
  }

  async getDetailedStaffUsageReport() {
    if (this.offset === 1) {
      this.videoList = [];
    }
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      classroom_id: this.classroom_id,
      subject_id: this.subject_id,
      department_id: this.department_id? this.department_id : this.searchForm.controls["depname"].value,
      professor_id: this.professor_id? this.professor_id : this.searchForm.controls["proname"].value,
      offset: this.offset,
      limit: this.limit,
      session_id: this.findedVal?.id,
    };
    this.getVideo = await this.globalService.get(
      "classVideoDetail/get-detailed-staff-report",
      filter
    );
    const dateKeyExists = this.chiparray.some((chip) => chip.startsWith("Date :"));

    if (!dateKeyExists) {
      this.chiparray.push("Date :" + " " + filter.start_date + " - " + filter.end_date);
    }
    this.videoList = this.getVideo["content"]["rows"];
    this.countvalue = this.getVideo["content"].count;

    if (this.getVideo["status"] === 200) {
      this.pageshow = true;
    }
    this.videoList1 = [];
    this.videoList.map((item) => {
      this.videoList1.push(item);
    });

    if (this.pageshow === true) {
      this.page_count = [];
      let page_count = Math.ceil(this.countvalue / this.limit);
      if (page_count > 1) {
        this.htmlpageshow = true;
      } else {
        this.htmlpageshow = false;
      }
      this.spinner.hide();
    } else {
      this.spinner.hide();
      this.showLoadMore = true;
    }
    (error) => {
      this.videoList = [];
      this.spinner.hide();
      this.showLoadMore = true;
    };

    this.spinner.hide();
    this.dropboxdown();
  }

  async exportAsXLSX(): Promise<void> {
    this.spinner.show();
    var count = 1000;

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      classroom_id: this.classroom_id,
      department_id: this.department_id,
      offset: this.offset ? this.offset : 0,
      limit: count,
      isdownload: true,
      session_id: this.findedVal?.id,
    };
    this.getVideo = await this.globalService.get(
      "classVideoDetail/get-detailed-staff-report",
      filter
    );

    this.excelVideoList = this.getVideo["content"]["rows"];

    this.uivideoList = this.excelVideoList.map((item: any) => {
      return {
        STAFF_NAME: `${item.first_name} ${item.last_name}`,
        DEPARTMENT: item.department_name,
        CLASSROOM_NAME: item.classroom_name,
        CLASSROOM_NUMBER: item.classroom_no,
        SUBJECT_NAME: item.subject_name,
        VIDEOS: item.inactive_video,
        VIDEOS_CAPTURED: item.captured_video,
        NOT_COMPLETED_VIDEOS: item.noncaptured_video,
        TOTAL_CLASSES: item.total_classes,

      };
      
    });
    this.spinner.hide();
    this.ExcelServicesService.exportAsExcelFile(
      this.uivideoList,
      "Detailed_Staff_Usage_Report" + "" + [this.recrange]
    );
    this.recrange = "";
    this.offset = 1;
    this.spinner.hide();
  }

  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = this.professorname["content"];
    if (this.storageService.getRole() == 4 && this.hod !== 1) {
      this.professor_id = this.storageService.getProfessor();
      if (this.professor_id != undefined && this.professor_id != "") {
        var proffessor = this.professorData.filter(
          (x) => x.id == this.professor_id
        );
        if (proffessor.length > 0 && proffessor[0]) {
          this.chiparray.push(
            "Proff:" +
              " " +
              proffessor[0].first_name +
              " " +
              proffessor[0].last_name
          );
        }
      }
    }
    this.spinner.hide();
  }

  openScrollableContent(longContent) {
    this.findedVal = null;
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
    // this.searchForm.reset();
    if(!this.forms["session"].setValue){
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );}
    this.onSessionChangeEvent(true);
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    if (this.storageService.getRole() == 4 && this.hod !== 1) {
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].disable(); 
    }
  }

  async openXl(
    content,
    classroom_id,
    batch_id,
    video_date,
    count,
    department_id,
    subject_id
  ) {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      classroom_id: classroom_id,
      department_id: department_id,
      subject_id: subject_id,
      batch_id: batch_id,
      camera_start: video_date,
      camera_end: video_date,
      limit: count,
      offset: 1,
    };
    this.getAllVideoDetails = await this.globalService.get(
      "classVideoDetail/get-all-video-details",
      filter
    );
    this.allVideoDetails = this.getAllVideoDetails["content"]["rows"];
    this.allVideoDetailsCountvalue = this.getAllVideoDetails["content"].count;
    this.modalService.open(content, { size: "xl" });
    this.spinner.hide();
  }

  loadMore(index) {
    this.pageshow = true;
    this.offset = index;
    this.getDetailedStaffUsageReport();
  }
  previous() {
    this.pageshow = true;
    this.offset = this.offset - 1;
    this.getDetailedStaffUsageReport();
  }
  next() {
    this.pageshow = true;
    this.offset = this.offset + 1;
    this.getDetailedStaffUsageReport();
  }

  doFilter() {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.filter != undefined && this.filter != "") {
      if(this.searchForm.controls["session"]?.value) {
        this.chiparray.push(
          "Session : " + this.searchForm.controls["session"]?.value
        );
      }
      // this.chiparray.push(
      //   "Date :" + " " + this.filter_from + " - " + this.filter_end
      // );
      if (this.professor_id != undefined && this.professor_id != "") {
        var proffessor = this.professorData.filter(
          (x) => x.id == this.professor_id
        );
        if (proffessor.length > 0 && proffessor[0]) {
          this.chiparray.push(
            "Proff:" +
              " " +
              proffessor[0].first_name +
              " " +
              proffessor[0].last_name
          );
        }
      }
      if (this.classroom_id != undefined && this.classroom_id != "") {
        var classroom = this.class.filter((x) => x.id == this.classroom_id);
        this.chiparray.push("Class:" + " " + classroom[0].name);
      }
      if (this.department_id != undefined && this.department_id != "") {
        var dept = this.departmentData.filter(
          (x) => x.id == this.department_id
        );
        this.chiparray.push("Dept:" + " " + dept[0].name);
      }
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData1.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }
    this.classroom_id = this.searchForm.controls['class_room_no']?.value;
    this.department_id =  this.department_id ? this.department_id : this.searchForm.controls["depname"]?.value ;;
    this.pageshow = true;
    this.offset = 1;
    this.getDetailedStaffUsageReport();
  }
  res() {
    this.forms["date"].setValue(null);
    this.getFilterDate(null);
    this.chiparray = [];
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData?.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    ) || null;
    this.chiparray.push(
      "Session : " + this.searchForm.controls["session"]?.value
    );
    this.filtervalues = false;
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      var dept = this.departmentData.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
      this.professor_id = null;}
      if (this.storageService.getRole() == 4 && this.hod != 1) {
      var proff = this.professorData.filter((x) => x.id == this.professor_id);
      if (proff.length > 0 && proff[0]) {
        this.chiparray.push("Proff:" + " " + proff[0].first_name + " " + proff[0].last_name);
      }
      this.department_id = null;}
    if (this.storageService.getRole() != 4) {
      this.department_id = null;
      this.professor_id = null;
    }
    this.forms["date"].setValue([moment(new Date()), moment(new Date())]);
    this.getFilterDate([moment(new Date()), moment(new Date())]);
    this.classroom_id = null;
    this.subject_id = null;
    this.filter_from = moment(new Date()).format("YYYY-MM-DD");
    this.filter_end = moment(new Date()).format("YYYY-MM-DD");
    this.videoList = [];
    this.prolength = 0;
    this.total_count = 0;
    this.countvalue = 0;
    // this.searchForm.reset();
    this.getDetailedStaffUsageReport();   
    this.pageshow = true;
    this.offset = 1;
  }
  paginationCount(value) {
    this.offset = 1;
    if (value >= 5) {
      this.limit = value;
    }
    this.getDetailedStaffUsageReport();
  }

  async openXls(content, selectedList, summary_type) {
    this.selectedList = {
      ...selectedList,
      summary_type: summary_type
    };
    this.modalService.open(content, { size: "xl" });
  }
}
